(function() {
  const whatsappNumber = '8764587554';
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;
  
  const button = document.createElement('a');
  button.href = whatsappUrl;
  button.target = '_blank';
  button.rel = 'noopener noreferrer';
  button.id = 'whatsapp-button';
  button.innerHTML = `
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421-7.403h-.004a9.87 9.87 0 00-4.869 1.171c-1.519.754-2.753 1.771-3.745 3.05C2.954 10.487 2.424 12.04 2.424 13.687c0 1.193.266 2.369.77 3.468l.052.101L2.88 22l4.832-1.265.1.046c1.020.509 2.188.77 3.468.77 5.338 0 9.703-4.365 9.703-9.703 0-2.591-.994-5.028-2.799-6.86-1.805-1.831-4.204-2.84-6.751-2.84m0 17.52h-.003c-1.112 0-2.204-.29-3.155-.823l-.116-.062-4.018 1.053 1.091-3.537-.073-.115A8.671 8.671 0 013.6 13.687c0-4.786 3.897-8.684 8.684-8.684 2.312 0 4.474.902 6.104 2.553 1.629 1.651 2.527 3.807 2.527 6.131 0 4.775-3.898 8.674-8.684 8.674"/>
    </svg>
  `;
  
  const style = document.createElement('style');
  style.textContent = `
    #whatsapp-button {
      position: fixed;
      bottom: 80px;
      right: 20px;
      width: 60px;
      height: 60px;
      background-color: #25D366;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 999;
      transition: all 0.3s ease;
      color: white;
      text-decoration: none;
    }
    
    #whatsapp-button:hover {
      background-color: #20BA5A;
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
      transform: scale(1.1);
    }
    
    #whatsapp-button svg {
      width: 32px;
      height: 32px;
    }
    
    @media (max-width: 768px) {
      #whatsapp-button {
        width: 56px;
        height: 56px;
        bottom: 80px;
        right: 16px;
      }
      
      #whatsapp-button svg {
        width: 28px;
        height: 28px;
      }
    }
  `;
  
  document.head.appendChild(style);
  document.body.appendChild(button);
})();